import React from "react";
import { Heading, Link } from "@walmart-web/livingdesign-components";
import styles from "./recommendedquestions.module.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchGenAIQueryResponse, setAnswerSpinner } from "../../store/reducers/app";
import { GenerativeSearchReq, QueryType } from "../../types";
import { AppDispatch, RootState } from "../../store/store";
import { domain } from "../../store/constants";
import { v4 as uuidv4 } from "uuid";

const RecommendedQuestions = ({
  suggestedQuestions,
}: {
  suggestedQuestions: string[];
}) => {
  const userState = useSelector((state: RootState) => state.userDetails);
  const sessionId = useSelector((state: RootState) => state.sessionId);
  const headersAre = useSelector((state: RootState) => state.headers);

  const dispatch = useDispatch<AppDispatch>();

  const handleQuestionClick = (que: string) => {
    dispatch(setAnswerSpinner({ loading: true, searchQuestion: que }));
    const payload: GenerativeSearchReq = {
      query: que,
      metadata: {
        domain: domain,
        query_id: uuidv4(),
        user_id: userState.userId,
        session_id: sessionId,
        business_unit: userState.businessUnit,
      },
    };
    const logAnswerPayload = {
      sessionId: sessionId,
      queryId: payload.metadata.query_id,
      userId: userState.userId,
      state: userState.state,
      queryType: QueryType.SIMILAR,
      query: que,
      response: "",
      businessUnit: userState.businessUnit,
      createdTimestamp: new Date().toISOString(),
    };
    const reqData = { payload, logAnswerPayload,headers: headersAre };
    dispatch(fetchGenAIQueryResponse(reqData));
  };
  return (
    <div className={styles.recommendationQuestionParent}>
      <Heading size="small">Related Questions:</Heading>
      {suggestedQuestions.length > 0 ? (
        <div className={styles.recommendedQuestionLinks}>
          {suggestedQuestions.map((que: string) => (
            <Link
              placeholder={que}
              key={que}
              UNSAFE_className={styles.questionLink}
              onClick={() => handleQuestionClick(que)}
            >
              {que}
            </Link>
          ))}
        </div>
      ) : (
        <div className={styles.recommendedQuestionNoData}>
          No related questions found. Please modify your question and try again.
        </div>
      )}
    </div>
  );
};

export default RecommendedQuestions;
